(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.verogroveCardActionsReady) {
    window.verogroveCardActionsReady = true;
    const feedbackDuration = 2200;

    const runBuyNow = async (button) => {
      if (button.disabled) return;

      const originalLabel = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Preparing…';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(button.dataset.variantId), quantity: 1 }]
          })
        });

        if (!response.ok) throw new Error('Unable to add product');
        window.location.assign(`${root}checkout`);
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalLabel;
      }
    };

    const activateCardActions = (root = document) => {
      root.querySelectorAll('[data-verogrove-card-actions]:not([data-actions-ready])').forEach((actions) => {
        actions.dataset.actionsReady = 'true';

        actions.addEventListener('pointerdown', (event) => {
          event.stopPropagation();
          const card = actions.closest('product-card');
          if (!card || card.hasAttribute('data-no-navigation')) return;
          card.setAttribute('data-no-navigation', '');
          window.setTimeout(() => card.removeAttribute('data-no-navigation'), 1500);
        });

        actions.addEventListener('click', (event) => {
          const buyNowButton = event.target.closest('[data-verogrove-buy-now]');
          if (buyNowButton) {
            event.preventDefault();
            event.stopPropagation();
            runBuyNow(buyNowButton);
            return;
          }

          event.stopPropagation();
        });

        actions.addEventListener('shopify:cart:lines-update', (event) => {
          const button = actions.querySelector('button[name="add"]');
          const text = button?.querySelector('.add-to-cart-text');
          if (!button || !text || !event.promise) return;

          event.promise
            .then(({ detail }) => {
              if (detail?.didError) return;

              const originalLabel = button.dataset.originalLabel || text.textContent.trim();
              button.dataset.originalLabel = originalLabel;
              button.removeAttribute('data-added');
              button.dataset.verogroveConfirmed = 'true';
              button.disabled = true;
              text.textContent = button.dataset.addedLabel || 'Added';

              window.clearTimeout(Number(button.dataset.feedbackTimeout));
              const timeout = window.setTimeout(() => {
                text.textContent = originalLabel;
                button.disabled = false;
                button.removeAttribute('data-verogrove-confirmed');
                button.removeAttribute('data-feedback-timeout');
              }, feedbackDuration);
              button.dataset.feedbackTimeout = String(timeout);
            })
            .catch(() => {});
        });
      });
    };

    activateCardActions();

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('[data-verogrove-card-actions]')) {
            activateCardActions(node.parentElement || document);
          } else if (node.querySelector('[data-verogrove-card-actions]')) {
            activateCardActions(node);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

  }
  } catch(e) { console.error(e); }
})();

})();
